import tailwindConfig from "tailwind.config.js";
import resolveConfig from "tailwindcss/resolveConfig";

/* https://github.com/tailwindlabs/tailwindcss/issues/6422 */
export const twConfig = resolveConfig(tailwindConfig) as any;
